export default {
  busiStageList: state => state.busiStageList,
  busiOpportunityList: state => state.busiOpportunityList,
  CustomSelectData: state => state.CustomSelectData,
  busiOpportunityDetail: state => state.busiOpportunityDetail,
  busiVisitData: state => state.busiVisitData,
  busiSalesData: state => state.busiSalesData,
  busiFileData: state => state.busiFileData,
  busiLineList: state => state.busiLineList,
  busiSalesList: state => state.busiSalesList,
  busiContacts: state => state.busiContacts,
  detailContacts: state => state.detailContacts,
  teamList: state => state.teamList,
};
